import React, { Component } from 'react';
import {
  Link
} from 'react-router-dom';
import ReactDOM from 'react-dom';

import { setFlowDesired } from '../Functions';
import { Store, Flow } from '../Store';
import { Questions } from '../Data';
import { Svgs } from '../components/Svgs';

class Question extends Component {
  constructor(props) {
    super(props);

    this.state = {
      returned: null,
      current: null,
      currentObj: null,
      previous: null,
      answer: [],
      next: null
    };

    this.answerQuestion = this.answerQuestion.bind(this);  
  }

  componentDidMount() {

    document.querySelector('.app').classList.add('screen--questions');
    window.scrollTo(0,0);

    this.dom = ReactDOM.findDOMNode(this);
    void this.dom.offsetWidth;
    this.dom.classList.add('questions--animate-in');

    let previousQuestion, m, currentQuestionNo, a, n, currentObj;
    
    currentQuestionNo = this.props.data.questionNumber;
    currentObj = Questions[currentQuestionNo];

    console.log(Flow.completed);
    // if is already in flow completed
    if (Flow.completed.includes(currentQuestionNo)) {
      let q = Flow.completed.indexOf(currentQuestionNo) + 1;
      Flow.completed.splice(q, Flow.completed.length - q);

      // have gone back so set returned to be true
      this.setState({
        returned: true
      });

      setFlowDesired(currentQuestionNo, true);

    } else {
      Flow.completed.push(currentQuestionNo);

      this.setState({
        returned: false
      });

      setFlowDesired(currentQuestionNo, false);

    }

    if (Flow.completed.length === 1) {
      previousQuestion = '/';
    } else {
      previousQuestion = Questions[Flow.completed[Flow.completed.length - 2]].url;
    }

    m = Questions[currentQuestionNo].multi;

    if (m === 'False') {
      m = false;
    } else if(m === 'True') {
      m = true;
    }

    a = Store[currentQuestionNo].answer;
    
    /*if (Flow.desired.includes(currentQuestionNo.toString())) {
      let q = Flow.desired.indexOf(currentQuestionNo.toString());
      Flow.desired.splice(q, 1);
    }*/

    if (Store[currentQuestionNo].answer.length > 0) {

      /*for (let s = 0; s < Store[currentQuestionNo].answer.length; s++) {
        //console.log(Store[this.state.current].answer[s]);
        Flow.desired.push(currentObj.next[Store[currentQuestionNo].answer[s]]);
      }*/

      if (Flow.desired[Flow.desired.length-1] > Questions.length-1 && Flow.desired[Flow.desired.length-2] >= currentQuestionNo) {
        n = '/results';
      } else {
        let index = Flow.desired.findIndex(function(number) {
          return number > currentQuestionNo;
        });
        n = Questions[Flow.desired[index]].url;
      }

    } else {
      n = '/';
    }

    this.setState({
      multi: m,
      current: currentQuestionNo,
      currentObj: currentObj,
      previous: previousQuestion,
      answer: a,
      next: n
    });

    //console.log(Flow.desired);
    //console.log(Store);

  }

  componentWillUnmount() {
    document.querySelector('.app').classList.remove('screen--questions');
  }

  answerQuestion = (e, i) => {

    // answer data
    if (Store[this.state.current].answer.includes(i)) {

      // clear answer if exists
      let index = Store[this.state.current].answer.indexOf(i);
      Store[this.state.current].answer.splice(index, 1);
      this.setState({ answer: Store[this.state.current].answer });

      // clear desired out of flow desired
      //let q = Flow.desired.indexOf(this.state.currentObj.next[i]);
      //Flow.desired.splice(q, 1);

    } else {

      if (this.state.multi) {

        // save multiple choice answer
        Store[this.state.current].answer.push(i);
        this.setState({ answer: Store[this.state.current].answer });

      } else {

        // clear answers to allow for only one answer
        Store[this.state.current].answer.length = 0;

        // save single choice answer
        Store[this.state.current].answer.push(i);
        this.setState({ answer: Store[this.state.current].answer });

      }

    }

    // have gone back and changed decision so clear flow desired
    //if (this.state.returned) {
      //Flow.desired.length = 0;
    //}

    // loop through answers and add to desired in order
    /*for (let s = 0; s < Store[this.state.current].answer.length; s++) {
      //console.log(Store[this.state.current].answer[s]);
      Flow.desired.push(this.state.currentObj.next[Store[this.state.current].answer[s]]);
    }

    // remove duplicate questions from desired
    Flow.desired = Array.from(new Set(Flow.desired));

    Flow.desired.sort();

    console.log(Flow.desired);
    //console.log(Store[this.state.current].answer);
    //console.log(Store);*/

    setFlowDesired(this.state.current, false);

    // decide the next question to be answered
    if (Store[this.state.current].answer.length > 0) {

      let nextQuestionUrl;

      if (Flow.desired[Flow.desired.length-1] > Questions.length-1 && Flow.desired[Flow.desired.length-2] >= this.state.current) {
        nextQuestionUrl = '/results';
      } else {
        let self = this;
        let index = Flow.desired.findIndex(function(number) {
          return number > self.state.current;
        });
        console.log(Flow.desired[index]);
        nextQuestionUrl = Questions[Flow.desired[index]].url;
      }

      this.setState({ next: nextQuestionUrl });

    } else {

      this.setState({ next: '/' });

    }
    //console.log(Store);
  }
  
  render() {

    const options = this.props.data.options;
    let disableNextButton = true;
    if (this.state.next !== '/') {
      disableNextButton = false;
    }
    
    return (
      <React.Fragment>
        <div className={'questions questions--'+this.props.data.template}>
          <h2 className="questions__title">{this.props.data.question}</h2>
          <ul className="questions__answer-items">
            {options.map((item, i) =>
              <li key={i} className={this.state.answer.includes(i) ? 'questions__answer-item questions__answer-item--active' : 'questions__answer-item'}><button type="button" onClick={(e) => this.answerQuestion(e, i)}>{this.props.data.template.includes('icon') && <Svgs width="60" height="60" svg="ApLogo" class="questions__answer-item-icon" />}<span className="questions__answer-item-copy">{item}</span></button></li>
            )}
          </ul>
        </div>
        <div className="questions__nav">
          {this.state.previous &&
          <Link to={this.state.previous} className="btn questions__nav-prev"><Svgs width="8" height="8" svg="LeftChevron" /> <span>Previous</span></Link>
          }
          {this.state.next &&
          <Link to={this.state.next} className='btn questions__nav-next' disabled={disableNextButton}><span>Next</span> <Svgs width="8" height="8" svg="RightChevron" /></Link>
          }
        </div>
      </React.Fragment>
    );
  }
}

export default Question;



// WEBPACK FOOTER //
// ./src/screens/Question.js